module.exports = __webpack_public_path__ + "img/without-charger.d463603.svg";